import { render } from "./FormContent.vue?vue&type=template&id=fd6c4db6&scoped=true"
import script from "./FormContent.vue?vue&type=script&lang=js"
export * from "./FormContent.vue?vue&type=script&lang=js"

import "./FormContent.vue?vue&type=style&index=0&id=fd6c4db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6c4db6"]])

export default __exports__